import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ScannerService } from '../../services/scanner.service';
import { UtilityServiceService } from '../../services/utility-service.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';


@Component({
  selector: 'app-list-scanner',
  templateUrl: './list-scanner.component.html',
  styleUrls: ['./list-scanner.component.css']
})
export class ListScannerComponent implements OnInit {
  vTypes: any = [];
  isRemove = false;
  removeRef: any;
  criteria = 'code';
  direction = false;  
  lblHeading = '';

  popoverTitle = 'Delete Scanner';
  popoverMessage = 'Are you sure you want to delete Scanner?';
  confirmText = 'Yes <i class="glyphicon glyphicon-ok"></i>';
  cancelText = 'No <i class="glyphicon glyphicon-remove"></i>';
  confirmClicked = false;
  cancelClicked = false;
  deleteConfirm = '';
  message = "Loading Scanner...";

  public isLoading = false;
  isEmpty: boolean = false;
  showNum: number = 10;

  constructor(private service: ScannerService,private utility: UtilityServiceService,private toastr:ToastrService,private location: Location ,private router: Router) { }

  ngOnInit() {
    this.onChangeHeandig();
    this.reload();
    this.utility.page = 1;
  }

  reload() {
    this.isLoading = true;
    this.service.getScanners().subscribe(result => {
      this.vTypes = result;
      this.utility.onSort(1);     
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      this.isEmpty = true;
    });
  }

  onDelete(id: any) {
    this.service.delete(id).subscribe(result => {

      // this.dialogService.addDialog(AlertComponent, { title: 'Delete Scanner', message: `Scanner ${this.removeRef.code} deleted.`, bold: `${this.removeRef.code}` });
      this.toastr.success(`Scanner ${this.removeRef.device_id} deleted.`,'Delete Scanner');
      if (result != null) {
        this.onNo();
        this.reload();
      }
      this.onChangeHeandig();
      window.location.reload();

    }, error => {
      error = error.json();
      // this.dialogService.addDialog(ErrorComponent, { title: 'Delete Scanner', message: `Scanner ${this.removeRef.code} was not deleted.`, statuscode: error.Status, url: error.Uri, servermessage: error.Message });
      this.toastr.error(`Scanner ${this.removeRef.device_id} was not deleted.`,'Delete Scanner');

    });
  }

  onSort() {
    this.direction = !this.direction;
  }

  onConfirm(doc: any) {
    this.removeRef = doc;
    this.deleteConfirm = `Are you sure you want to delete Scanner <strong>${this.removeRef.device_id}</strong>?`;        
    this.onChangeHeandig(false);
    this.isRemove = true;
  }

  onNo() {
    this.isRemove = false;
    this.onChangeHeandig();
  }

  onChangeHeandig(change: boolean = true) {
    this.lblHeading = (change) ? 'Scanners' : 'Delete Scanner';    
  }

  reloadPage() {
    this.router.navigate(this.router.config, {skipLocationChange: true}).then(() => {
      this.router.navigated = false;
      this.router.navigate([this.router.url], {skipLocationChange: true, replaceUrl: true});
    });
  }


}
